import type { CategoryContent } from '../../row.js';

/**
 * East Asian Development, second chunk. Correct option first; rotated at build.
 * Kept strictly to 1980-2000 economic/development content - see EAST_ASIA in
 * asia.ts for the rest. Content outside that window moved to East Asian
 * History (asia2.ts).
 */
export const MORE_EAST_ASIA: CategoryContent = {
  msc: [
    [
      'De Chinese Speciale Economische Zones, ingesteld vanaf 1980, omvatten welke stad?',
      [
        'Shenzhen',
        'Chongqing, als binnenlandse proefstad',
        'Tianjin, als noordelijke tegenhanger van Shanghai',
        'Dalian, geopend onder het programma voor kuststeden',
      ],
      0,
      'Shenzhen, Zhuhai, Shantou en Xiamen kwamen eerst. Dalian en Tianjin werden later geopend, onder het besluit over kuststeden van 1984.',
    ],
    [
      'Wat deed het Chinese systeem van huishoudelijke verantwoordelijkheid?',
      [
        'Kende productieverantwoordelijkheid toe aan huishoudens, terwijl grond collectief eigendom bleef',
        'Privatiseerde landbouwgrond volledig naar individuele boerenhuishoudens',
        'Voegde communes samen tot grotere staatslandbouwbedrijven met loonarbeid',
        'Voerde verplichte graanaankoop tegen marktprijzen in',
      ],
      0,
      'Ingevoerd tussen 1979 en 1983. Het leverde de grootste stijging van de landbouwproductie in de hele hervormingsperiode op en liet de eigendomsvraag bewust onopgelost.',
    ],
    [
      'Japans "zeepbeleconomie" bereikte haar piek in welk jaar?',
      ['1989', '1985', '1993', '1997'],
      0,
      'De Nikkei piekte in december 1989 en de grondprijzen ongeveer een jaar later. 1985 is het Plaza-akkoord, 1997 de bankencrisis.',
    ],
    [
      'Wat vereiste het Koreaanse IMF-programma van 1997-98, het meest omstreden?',
      [
        'Hoge rentetarieven en snelle financiële herstructurering, samen met openstelling van het kapitaalverkeer',
        'Onmiddellijke devaluatie van de won ten opzichte van de dollar en de yen',
        'Nationalisatie van de industriële activa van de chaebols, met latere doorverkoop aan buitenlandse kopers',
        'Terugtrekking uit het WTO-toetredingsproces in afwachting van hervormingen',
      ],
      0,
      'De procyclische begrotings- en monetaire voorwaarden zijn wat de latere literatuur - ook van binnen het Fonds zelf - als een fout beschouwt.',
    ],
    [
      'Waarnaar verwijst de "hervorming van staatsbedrijven" in het China van de jaren negentig?',
      [
        'Het beleid van "de grote vastpakken, de kleine loslaten"',
        'Volledige privatisering van alle industriële bedrijven boven een bepaalde omvang',
        'De overdracht van eigendom van staatsbedrijven aan hun werknemers',
        'De omvorming van staatsbedrijven tot township- en dorpsbedrijven',
      ],
      0,
      'Zhu Rongji\'s herstructurering. De omvang van de ontslagen valt gemakkelijk weg naast de groeicijfers van diezelfde jaren.',
    ],
    [
      'In welk jaar voerde Hongkong zijn koppeling van de munt aan de Amerikaanse dollar in (het Linked Exchange Rate System)?',
      ['1983', '1997', '1990', '1978'],
      0,
      'Ingevoerd oktober 1983 op 7,80 per dollar om vertrouwen te herstellen na onzekerheid over 1997-overdracht. De koppeling doorstond de Aziatische crisis van 1997-98, in tegenstelling tot andere munten, al met deflatie als gevolg.',
    ],
    [
      'Waarop richtte Singapore zich vooral in reactie op zijn recessie van 1985-86, de eerste sinds de onafhankelijkheid?',
      [
        'Een verlaging van de werkgeversbijdragen aan het CPF om de loonkosten te verlagen en het exportvermogen te herstellen',
        'Een devaluatie van de Singaporese dollar ten opzichte van de Amerikaanse dollar om de exportconcurrentie te versterken',
        'Nationalisatie van verliesgevende productiebedrijven om massaontslagen te voorkomen',
        'De invoering van het eerste wettelijke minimumloon van Singapore om de binnenlandse vraag te ondersteunen',
      ],
      0,
      'Regering zag recessie van 1985-86 als kostenprobleem; verlaagde werkgeversaandeel in CPF van 25% naar ~10%. Dit drukte loonkosten zonder wisselkoersverandering, wat Singapores voorkeur voor loonflexibiliteit weerspiegelt.',
    ],
    [
      'In welk jaar werd het Hsinchu Science-Based Industrial Park opgericht, het Taiwanese model voor de omschakeling naar halfgeleiders?',
      ['1980', '1987', '1973', '1995'],
      0,
      'Hsinchu opende in 1980 om VS-ingenieurs terug te halen voor halfgeleiders/electronica (later TSMC). Via ITRI gebruikte Taiwan belastingvrijstellingen, leningen en douaneversoepeling om bedrijven op de waardeketen te tillen.',
    ],
    [
      'Wat bekrachtigde het 14e Congres van de Chinese Communistische Partij formeel in 1992?',
      [
        'Het uitroepen van een "socialistische markteconomie" tot officieel doel van de hervorming',
        'De landelijke afschaffing van het huishoudregistratiesysteem (hukou)',
        'Volledige privatisering van alle staatsbedrijven binnen vijf jaar',
        'Een vast tijdschema voor de volledige convertibiliteit van de renminbi op de kapitaalrekening',
      ],
      0,
      'October 1992 bekrachtigde het 14e Congress "socialistische markteconomie" als doel, na Dengs Zuidelijke Rondreis. Dit eindigde ideologische onduidelijkheid: markten zouden, niet centrale planning, middelen toewijzen.',
    ],
    [
      'Waaruit bestond Malaysia\'s reactie op de Aziatische financiële crisis, ingevoerd in september 1998?',
      [
        'Een vaste wisselkoers en kapitaalcontroles die de ringgit aan de dollar koppelden',
        'Een IMF-standbyprogramma met conventionele begrotings- en monetaire voorwaarden',
        'Het vrij laten zweven van de ringgit terwijl de rente scherp werd verhoogd om die te verdedigen',
        'Nationalisatie van de gehele binnenlandse banksector',
      ],
      0,
      'September 1998: Mahathir koppelde ringgit aan 3,80/dollar en verbood buitenlandse handel, trotseerde IMF. Dit liet Bank Negara de rente verlagen. Maleisië\'s herstel leek op IMF-landen, zonder voorwaarden.',
    ],
  ],
  phd: [
    [
      'Wat deed de Chinese "duale prijsstrategie" bij de hervorming?',
      [
        'Behield de geplande quota tegen plafondprijzen, terwijl productie boven het quotum tegen marktprijzen mocht worden verhandeld',
        'Stelde afzonderlijke wisselkoersen vast voor handels- en kapitaaltransacties',
        'Paste verschillende belastingtarieven toe op staats- en niet-staatsbedrijven',
        'Handhaafde afzonderlijke, administratief door het ministerie van Arbeid vastgestelde loonschalen voor stedelijke en plattelandswerknemers',
      ],
      0,
      'Lau, Qian en Roland betoogden dat dit Pareto-verbeterend kon zijn, zonder de rentevernietiging van een liberalisering in één stap - het referentiegeval tegenover schokkuur.',
    ],
    [
      'Om welke reden zou de monitoring door Japanse hoofdbanken zijn verzwakt?',
      [
        'Liberalisering van de kapitaalmarkt liet de beste kredietnemers zich rechtstreeks financieren, waardoor alleen de slechtste bij banken overbleven',
        'De "window guidance" van de Bank of Japan werd halverwege de jaren tachtig afgeschaft',
        'Kruiselings aandelenbezit werd verboden door het herziene handelswetboek, waardoor banken hun aandelenbelangen in klanten moesten verkopen',
        'Hoofdbanken moesten hun aandelenbelangen afstoten onder Basel I',
      ],
      0,
      'Averechtse selectie in de kredietportefeuille is het mechanisme dat doorgaans wordt genoemd voor hoe de kredietverlening in het zeepbeltijdperk zo slecht kon worden.',
    ],
    [
      'Waar gingen de Koreaanse "big deals" van 1998 over?',
      [
        'Door de staat georkestreerde ruilingen van bedrijfsonderdelen tussen chaebols om overcapaciteit te verminderen',
        'De verkoop van chaebol-dochters aan buitenlandse strategische investeerders',
        'Omzetting van schuld in aandelen bij de staatsbanken',
        'De opsplitsing van de vijf grootste groepen in onafhankelijke bedrijven',
      ],
      0,
      'Halfgeleiders, petrochemie, luchtvaart. Het is het duidelijkste geval van een zogenaamd liberaliserende overheid die toch de industriële structuur bleef aansturen.',
    ],
    [
      'Hoe worden de gevolgen van het Plaza-akkoord voor Japan meestal beschreven?',
      [
        'Scherpe waardestijging van de yen, gevolgd door monetaire verruiming',
        'Een instorting van de export die een onmiddellijke recessie veroorzaakte',
        'Een snelle daling van het overschot op de lopende rekening naar evenwicht',
        'Een permanente verplaatsing van de productie naar Noord-Amerika',
      ],
      0,
      'De causale keten van endaka naar verruiming naar zeepbel wordt in de details betwist, maar de volgorde zelf staat niet ter discussie.',
    ],
    [
      'Wat was de centrale en meest bekritiseerde claim van het "East Asian Miracle"-rapport?',
      [
        'Dat groei grotendeels werd verklaard door fundamentals',
        'Dat industriebeleid in de hele regio de belangrijkste groeimotor was',
        'Dat de groei van de regio onhoudbaar was zonder financiële liberalisering',
        'Dat ongelijkheid noodzakelijk toenam bij snelle groei in alle acht gevallen',
      ],
      0,
      'Het rapport van de Wereldbank uit 1993. Wade en Amsden lazen het als het terugprojecteren van het bewijs op de reeds bestaande overtuigingen van de instelling.',
    ],
    [
      'Waarom was het financiële debacle van Kia Motors in juli 1997 vooral belangrijk voor de Koreaanse crisis?',
      [
        'Het legde bloot hoe kwetsbaar door schulden gefinancierde bedrijfshefboom was geworden, nog voordat de besmetting toesloeg',
        'Het markeerde het eerste Koreaanse bedrijf dat formeel werd genationaliseerd onder het IMF-programma van december',
        "Het veroorzaakte de eerste beheerde zweving van de won in maart 1997, maanden voor de crisis in Thailand",
        'Het leidde tot de onmiddellijke ineenstorting van de merchantbanksector, nog voor enig overheidsoptreden',
      ],
      0,
      'Kia failleerde juli-september 1997; toonde schuldfinanciering voorbij rendement vóór regionale besmetting. Regering aarzelde tussen nationalisatie/fusie, wat buitenlandse crediteuren opvatten als controle-verlies. Hyundai nam Kia over.',
    ],
    [
      'Waarnaar verwijst Japans "jusen"-crisis van het midden van de jaren negentig?',
      [
        'De afwikkeling van gefaalde niet-bancaire hypotheekverstrekkers, waarvan de verliezen werden verdeeld tussen banken, agrarische coöperaties en de staat',
        'Het falen van het eigen beleggingsonderdeel van het postspaarsysteem',
        'De directe nationalisatie van Japans grote stedelijke banken',
        'Een overheidsreddingsoperatie voor consumentenkredietbedrijven (sarakin)',
      ],
      0,
      'Jusen waren hypotheekmaatschappijen die failliet gingen door vastgoedspeculatie. Afwikkeling 1995-96 was politiek explosief: landbouwcoöperaties moesten beschermd worden met publiek geld - een eerste in Japan. Dit maakte reddingsoperaties zichtbaar.',
    ],
    [
      'Waarom is het Recruit-schandaal van 1988-89 in Japan vooral belangrijk voor de geschiedenis van de zeepbeleconomie?',
      [
        'Het onthulde hoe toewijzingen van aandelen vóór de beursgang aan politici en ambtenaren invloed kochten tijdens de vastgoedspeculatie',
        'Dat MITI systematisch de industriële productiecijfers had vervalst gedurende de jaren tachtig',
        'Dat het discontoloket van de Bank of Japan een politiek fonds voor onder-de-tafel-betalingen had gefinancierd',
        'Dat kruiselings aandelenbezit binnen keiretsu de anti-monopoliewet had geschonden',
      ],
      0,
      'Recruit-schandaal (1988): niet-genoteerde aandelen onder 90+ politici/ambtenaren als tegenprestatie. Dit toonde dat politieke toegang tegen gegarandeerde winsten werd geruild. Premier Takeshita trad af; institutioneel verval.',
    ],
    [
      'Waarop richtte het Amerikaans-Japanse Structural Impediments Initiative (1989-90) zich, in tegenstelling tot eerdere sectorspecifieke handelsgeschillen?',
      [
        "Japans eigen binnenlandse structuren - distributie, grondgebruik, keiretsu-banden - als onderliggende oorzaken van het handelsonevenwicht",
        'Japanse invoertarieven op fabrieksgoederen in het bijzonder',
        'Het wisselkoersmechanisme tussen yen en dollar rechtstreeks',
        "Japans invoerquota op landbouwproducten, geïsoleerd bekeken",
      ],
      0,
      'Escaleerde van sectorgeschillen naar claim dat Japans structuren (distributie, grondgebruik, keiretsu) het handelsonevenwicht in stand hielden. Yenstijging na Plaza hielp niet, dus was probleem structureel. Japan beloofde veranderingen; deels effectief.',
    ],
    [
      'Waarom mislukte China\'s poging tot algehele prijshervorming in 1988 om tot blijvende liberalisering te leiden?',
      [
        'De aankondiging veroorzaakte paniekaankopen en het massaal opnemen van spaartegoeden, wat de inflatie aanwakkerde en een terugtrekking afdwong',
        'De kust-SEZ\'s weigerden de nieuwe prijsschema\'s over te nemen',
        'Provinciale overheden blokkeerden de hervorming door een eensgezind fiscaal verzet',
        'Een veto van de Staatsraad draaide de hervorming terug voordat ze werd doorgevoerd',
      ],
      0,
      'Midden 1988: aankondiging prijsliberalisering leidde tot paniekaankopen en bankopnames. Inflatie boven 18%. Staat trok zich terug; hervormers en conservatieven verdeelden. Gaf stedelijke zorgen die naar Tiananmen 1989 voerden.',
    ],
    [
      'Wat deed de unificatie van Chinas wisselkoerssysteem in januari 1994 precies?',
      [
        'Voegde de officiële koers en de swapmarktkoers samen, waardoor de yuan in feite devalueerde naar ongeveer 8,7 per dollar',
        'Koppelde de yuan voor het eerst aan een valutamandje',
        'Beëindigde het systeem van vreemde-valutacertificaten, maar alleen voor toeristen',
        'Verleende Chinese bedrijven volledige convertibiliteit op de lopende rekening',
      ],
      0,
      'Januari 1994: China unificeerde twee wisselkoersen op ~8,7 yuan/dollar (grote devaluatie). Schafte vreemde-valutacertificaten af, bewoog naar lopende-rekening convertibiliteit (1996). Dit stimuleerde export en verwijderde arbitrage.',
    ],
    [
      'Hoeveel bedroeg het door het IMF geleide reddingspakket voor Zuid-Korea van december 1997 ongeveer, en wat onderscheidde de structuur ervan?',
      [
        'Ongeveer 57 miljard dollar, met een combinatie van IMF-, Wereldbank- en ADB-fondsen plus een bilaterale "tweede verdedigingslinie"',
        'Ongeveer 17 miljard dollar, uitsluitend gefinancierd via de gewone standbyfaciliteit van het IMF',
        'Ongeveer 40 miljard dollar, volledig uitgekeerd als onvoorwaardelijke begrotingssteun',
        'Ongeveer 100 miljard dollar, rechtstreeks gefinancierd door de centrale banken van de G7 buiten het IMF om',
      ],
      0,
      'December 1997: ~57 miljard dollar pakket, toen grootste IMF-operatie: standby 21 miljard plus Wereldbank/ADB en bilaterale "tweede verdedigingslinie" van VS/Japan. Structuur maakte totaal groter zonder alles meteen uit te keren. Korea gebruikte IMF/multilateraal; bilateraal niet nodig.',
    ],
  ],
  professor: [
    [
      'Wat betoogde de kritiek van Young en Krugman op de Oost-Aziatische groei?',
      [
        'Groei kwam voort uit accumulatie van productiefactoren in plaats van winst aan totale productiviteit',
        'Groeicijfers werden systematisch overdreven door statistische overheidsinstanties',
        'Groei hing af van verbeteringen in de ruilvoet die niet konden voortduren',
        'Groei concentreerde zich in niet-verhandelbare sectoren en kon daardoor niet doorgaan',
      ],
      0,
      'Krugmans "The Myth of Asia\'s Miracle" (1994) populariseerde de rekenkunde van Young en Kim. Later werk met een betere correctie voor kapitaalkwaliteit heeft dit aanzienlijk afgezwakt.',
    ],
    [
      'Welk mechanisme benoemt de Japanse literatuur over "zombiebedrijven"?',
      [
        'Toegeeflijkheid van banken hield onhoudbare bedrijven in leven, wat markten verstopte en de investeringen van nieuwkomers deed dalen',
        'Bedrijven hoopten geld op in plaats van te investeren, vanwege deflatieverwachtingen',
        'Overheidsuitgaven aan publieke werken verdrongen private investeringen in dezelfde sectoren',
        'Levenslange werkgelegenheid verhinderde herverdeling van arbeid tussen sectoren of regio\'s, waardoor ontslagen werknemers ter plaatse bleven',
      ],
      0,
      'Caballero, Hoshi en Kashyap. De belangrijke claim is de externaliteit: de schade treft de gezonde bedrijven, niet de bedrijven die overeind worden gehouden.',
    ],
    [
      'Hoe wordt de karakterisering "hervorming zonder verliezers" van de jaren tachtig in China betwist?',
      [
        'De herstructurering van de jaren negentig brengt zeer grote verliezen met zich mee',
        'De plattelandshervormingen verlaagden de inkomens van boeren van het begin af aan',
        'Prijsliberalisering leidde tot een onmiddellijke daling van de reële stedelijke lonen',
        'De speciale economische zones onttrokken investeringen aan de bestaande industrie',
      ],
      0,
      'De formulering van Lau, Qian en Roland gold voor het eerste decennium. Naughtons punt is dat de boekhouding er anders uitziet zodra de ontslagen bij staatsbedrijven worden meegerekend.',
    ],
    [
      'Wat is de betekenis van de ineenstorting van Japans "convooisysteem" in de jaren negentig voor financiële regelgeving?',
      [
        'Het maakte een einde aan de praktijk om reddingsoperaties zo te regelen dat geen instelling zichtbaar failliet ging',
        'Het bracht het toezicht op banken over van de Bank of Japan naar het ministerie van Financiën',
        'Het voerde voor het eerst depositoverzekering in',
        'Het verplichtte banken hun kredietportefeuilles jaarlijks tegen marktwaarde te waarderen',
      ],
      0,
      'De Financial Supervisory Agency en het afwikkelingskader van 1998 zijn het institutionele restant. Depositoverzekering bestond al veel langer.',
    ],
    [
      'Wat beweert de opvatting van "de ontwikkelingsstaat in verval" over Japan na 1990?',
      [
        'De instellingen die de inhaalgroei coördineerden, werden een last zodra de voorhoede was bereikt',
        'De bureaucratische capaciteit stortte in doordat de instroom van elite-universiteiten afnam',
        'Het industriebeleid werd volledig opgegeven onder buitenlandse druk',
        'De staat verloor de controle over het banksysteem aan buitenlandse aandeelhouders',
      ],
      0,
      'De algemene vorm van de claim - dat instellingen voor inhaalgroei anders zijn dan instellingen voor de voorhoede - is ook hoe diezelfde literatuur Chinas huidige probleem leest.',
    ],
    [
      'Waarom is de interventie van de Hong Kong Monetary Authority in de aandelen- en futuresmarkten van augustus 1998 belangrijk?',
      [
        'Een currency board kocht rechtstreeks aandelen op, om een "dubbele slag" van valuta- en aandelenspeculatie tegen te gaan',
        'Het markeerde het loslaten van de vaste koppeling ten gunste van een beheerde zweving',
        'Het werd gezamenlijk gecoördineerd met de Chinese centrale bank om de renminbi te verdedigen',
        'Het volgde op IMF-voorwaarden verbonden aan een standbylening voor Hongkong',
      ],
      0,
      'Augustus 1998: HKMA kocht ~118 miljard HK$ aandelen/futures tegen "dubbele slag" (hedgefondsen shorten dollar+aandelen). Buitengewoon voor currency board; koppeling hield stand, aandelen later met winst verkocht. Kritiek op verlies van marktprincipes.',
    ],
    [
      'Op welk empirisch punt draaide het debat vooral of de Aziatische crisis van 1997-98 werd gedreven door "fundamentals" of door "paniek"?',
      [
        'Of kortetermijnverplichtingen in dollars de reserves zo ver overtroffen dat een zelfvervullende bankrun mogelijk werd',
        'Of tekorten op de lopende rekening alleen al voorspelden welke landen werden getroffen',
        'Of vaste wisselkoersen zonder uitzondering in elk crisisland aanwezig waren',
        'Of kapitaalcontroles in elk land in hetzelfde kalenderjaar waren opgeheven',
      ],
      0,
      'Paniek-verhaal (Radelet, Sachs): schuld overtroffen reserves, zelfvervullende runs mogelijk ondanks gezonde fundamentals. Fundamentals-kamp (Corsetti, Pesenti, Roubini): echte zwaktes (overinvestering, zwak toezicht). Onderscheid bepaalde beleid: paniek vs aanpassing-nodig.',
    ],
    [
      'Waar plaatste de "moral hazard"-verklaring voor de investeringsboom in Oost-Azië vóór 1997, ontwikkeld door onder meer Ronald McKinnon en Huw Pill en weerklonken in Paul Krugmans essay uit 1998 over de crisis, het fundamentele probleem?',
      [
        'Impliciete overheidsgaranties aan banken en bevoorrechte bedrijven, waardoor ze konden lenen en investeren alsof het neerwaartse risico gesocialiseerd was',
        'Expliciete depositoverzekeringsstelsels die te vroeg in de volgorde van financiële liberalisering werden ingevoerd',
        'De vrijwel volledige afwezigheid van overheidsbetrokkenheid bij kredietallocatie door banken, waardoor investeringsrisico onbeprijsd bleef',
        'Monetaire verstrakking die binnenlandse banken dwong tot risicovollere, ongedekte leningen in vreemde valuta',
      ],
      0,
      'McKinnon, Pill, Krugman: impliciete overheidsgaranties veroorzaakten boom: banken/bedrijven financierden hefboomwerking zonder neerwaartse risico in te prijzen. Verschilt van paniek-versus-fundamentals op institutionele vertekening. Critici: garanties konden snelheid 1997 niet verklaren.',
    ],
    [
      'Waarover liepen de onderhandelingen van Indonesië met het IMF begin 1998 herhaaldelijk stuk, welk specifiek voorstel van Soeharto\'s adviseurs betreft?',
      [
        'Een currency board dat de rupiah vastzette op ongeveer 5.000 per dollar, verdedigd door Steve Hanke',
        'Een volledig vrij zwevende rupiah zonder enige ondergrens voor de reserves',
        'Volledige nationalisatie van de private banksector',
        'Een schuldmoratorium dat zowel de staats- als de private buitenlandse schuld dekte',
      ],
      0,
      'Begin 1998: Soeharto\'s team (Steve Hanke) drong currency board aan voor rupiah-dollar koppeling. IMF/buitenlandse regeringen verzetten zich: reserves/banksysteem niet gezond genoeg, zou speculatie uitlokken. Geschil vertraagde IMF-steun. Soeharto verliet idee mei 1998.',
    ],
    [
      'Waarom was Chinas Vennootschapswet van 1993 vooral belangrijk voor de hervorming van staatsbedrijven?',
      [
        'Ze gaf staatsbedrijven een juridische vorm - naamloze en besloten vennootschappen - voor de vennootschappelijkheid van de jaren negentig',
        'Ze legde voor het eerst een wettelijk plafond op aan staatsbezit in beursgenoteerde bedrijven',
        'Ze breidde de logica van het huishoudelijke verantwoordelijkheidssysteem formeel uit naar stedelijke staatsbedrijven',
        'Ze schiep een goedkeuringsvereiste door het Nationale Volkscongres voor het sluiten van elk groot bedrijf',
      ],
      0,
      '1993 Vennootschapswet gaf juridisch kader voor bedrijfshervorming via "vennootschappelijkheid". Gaf dekking aan Shanghai/Shenzhen-notiering (1990+), ondersteunde "moderner systeem". Staat behield controle via vennootschappelijkheid met kapitaaltoegang.',
    ],
    [
      'Welke koerswending markeerde Chun Doo-hwans stabilisatieprogramma van begin jaren tachtig in Korea, in verhouding tot het tijdperk van Park Chung-hee?',
      [
        'Een omschakeling van groei-tegen-elke-prijs zware-industriecampagnes naar stabilisatie en geleidelijke liberalisering',
        'Nationalisatie van de kernindustriële activa van de chaebols',
        'Het opgeven van exportpromotie ten gunste van importsubstitutie',
        "Koreas eerste vijfjarenplan, ter vervanging van ad-hocdoelstellingen",
      ],
      0,
      'Na Park\'s moord en schuldgefinancierde zware-industrie-campagne, koos Chun\'s team onder Kim Jae-ik begin jaren tachtig voor strak monetair beleid en geleidelijke liberalisering. Inflatie daalde; industriële promotie ontkoppelde van macro-beheer. Autoritaire instrumenten bleven.',
    ],
    [
      'Waarom wordt de oprichting van de beurzen van Shanghai en Shenzhen in 1990-91 door historici vaak als bijzonder betekenisvol gezien?',
      [
        'Ze gingen vooraf aan, in plaats van te volgen op, ontwikkeld vennootschapsrecht en duidelijke eigendomsrechten - een omkering van de gebruikelijke volgorde',
        'Het waren de eerste beurzen wereldwijd die uitsluitend in vreemde valuta genoteerde aandelen verhandelden',
        'Ze stonden vanaf het begin volledige buitenlandse eigendom van alle genoteerde A-aandelen toe',
        'Ze werden nadrukkelijk opgericht om het Drieklovendamproject te financieren',
      ],
      0,
      '1990-91: Shanghai/Shenzhen openden jaren voor vennootschaps- en effectenwetten, zonder eigendomsrechten duidelijk. Keerde gebruikelijke volgorde om: markt eerst, recht later. Verklaart: gesplitste structuren, zwakke minderheidsbescherming, staatcontrole.',
    ],
    [
      'Waarom is de verhoging van de Japanse consumptiebelasting van 3% naar 5% in april 1997, onder premier Hashimoto Ryutaro, vooral belangrijk in het macro-economische debat?',
      [
        'Ze wordt algemeen verantwoordelijk gehouden voor het fnuiken van een kwetsbaar herstel uit 1996, net toen bankfaillissementen en de Aziatische crisis toesloegen',
        'Ze ging gepaard met een even grote verlaging van de inkomstenbelasting, waardoor het netto begrotingsbeleid per ontwerp neutraal was',
        'Ze was volledig geoormerkt voor de financiering van de jusen-redding, met afscherming van de kosten van de algemene middelen',
        'Ze werd binnen een jaar teruggedraaid onder druk van het bedrijfsleven, voordat ze de consumptie kon beïnvloeden',
      ],
      0,
      'April 1997: Hashimoto verhoogde consumptiebelasting 3% naar 5% tijdens kwetsbaar herstel. Begrotingsverstrakking vóór bankfaillissementen en regionale crisis. BBP kromp voor eerst sinds oliecrises. Waarschuwing tegen te vroege sanering; Hashimoto noemde fout.',
    ],
    [
      'Waarin onderscheidt Zhao Ziyangs kuststrategie voor ontwikkeling, aangekondigd in 1988, zich in accent van het eerdere SEZ-beleid?',
      [
        'De SEZ-achtige behandeling voor export en investeringen werd uitgebreid over de hele kust, niet alleen een handvol enclaves',
        'Buitenlandse directe investeringen werden vervangen door binnenlands privaat kapitaal als primaire financieringsbron',
        'De speciale belastingbehandeling die de oorspronkelijke SEZ\'s had gekenmerkt, werd afgeschaft',
        'De geografische focus van de hervorming verschoof naar het binnenland van het Yangtze-bekken, vóór de kust',
      ],
      0,
      'Zhao\'s kuststrategie breidde SEZ-model naar ~160m mensen (niet alleen Shenzhen/Zhuhai/Shantou/Xiamen) via "vliegende ganzen" voor arbeidsintensieve productie uit Japan/Korea/Taiwan/Hongkong. Chinas regionale integratie verdiepte, maar kust-binnenland kloof nam toe.',
    ],
  ],
};
